import * as React from 'react';
import strings from 'owa-strings/owa-tasks-strings';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Datapoints } from '../datapoints';
import { getTodoModuleUrl } from 'owa-url';
import { logUsage } from 'owa-analytics';

let styles = require('./TodoAppLink.scss');

export default class TodoAppLink extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.wrapper}>
                <CommandButton
                    className={styles.linkButton}
                    styles={{ flexContainer: styles.buttonFlexContainer }}
                    onClick={this.openTodoApp}
                    text={strings.manageAllTasks}
                />
            </div>
        );
    }

    private openTodoApp = () => {
        window.open(getTodoModuleUrl(), '_blank');
        const datapoint = Datapoints.todoPanelManageAllTasks;
        logUsage(datapoint.name, datapoint.customData(), datapoint.options());
    };
}
